module.exports = __webpack_public_path__ + "static/media/status-bar.8a7c169d.svg";